// src/pages/HomePage.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useParams, useLocation } from 'react-router-dom';

import HomePageHeader from '@/components/page/home/HomePageHeader';
import HomePageFooter from '@/components/page/home/HomePageFooter';
import HomePageContent from '@/components/page/home/HomePageContent';
import LoaderWrapper from '@/components/page/home/LoaderWrapper';

import { useHomePageState, ViewModes, TeacherViewScopes } from '@/hooks/useHomePageState';

const HomePage = ({ initialMode }) => {
  const { slug } = useParams();
  const location = useLocation();

  const state = useHomePageState(initialMode, slug, location);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.7 }}
      className="min-h-screen bg-gradient-to-tr from-primary/10 via-background to-accent/10"
    >
      <div className="container mx-auto p-4 flex flex-col gap-6">
        <HomePageHeader />

        <LoaderWrapper loading={state.localLoading || state.schedulesLoading}>
          <HomePageContent 
            {...state}
            ViewModes={ViewModes}
            TeacherViewScopes={TeacherViewScopes}
          />
        </LoaderWrapper>

        <HomePageFooter />
      </div>
    </motion.div>
  );
};

export default HomePage;
